
const parameter = {
    supplyChartVisible : true,
    GPLlistPrice : false,
    downLoadPdfFatture: true,
    abilitaTipoUsoContatore:false
}

export default parameter